module.exports = __webpack_public_path__ + "static/assets/ac77b0649922419eaf005bf9821637d8.png";